import { TObject } from 'utils/types';

import { ICashierLimit } from './types';

export const normalizeCashierLimit = (data: TObject): ICashierLimit => {
  return {
    affiliateIdOperation: (data?.affiliateIdOperation as string) || '',
    affiliateIdValues: (data?.affiliateIdValues as string[]) || [],
    countryCode: (data?.countryCode as string) || '',
    currency: (data?.currency as string) || '',
    id: data?.id as number,
    maxAmount: data?.maxAmount as number,
    merchantId: data?.merchantId as number,
    merchantName: (data?.merchantName as string) || '',
    merchantTerminalId: data?.merchantTerminalId as number,
    merchantTerminalName: (data?.merchantTerminalName as string) || '',
    minAmount: data?.minAmount as number,
    paymentMethod: (data?.paymentMethod as string) || '',
    paymentMethodId: (data?.paymentMethodId as string) || '',
    transactionType: (data?.operation as string) || '',
  };
};
